(function () {
  const SLIDER_SELECTOR = '.b2b-technik__slider-wrap';
  const SCROLL_EDGE = 8;

  function getScrollStep(slider) {
    const list = slider.querySelector('.b2b-technik__list');
    const card = list && list.querySelector('.b2b-technik__card');
    if (card) {
      const style = list ? getComputedStyle(list) : null;
      const gap = style ? parseFloat(style.gap) || 0 : 0;
      return card.offsetWidth + gap;
    }
    return slider.clientWidth;
  }

  function updateButtons(slider, prevBtn, nextBtn) {
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    const atStart = maxScroll <= 0 || slider.scrollLeft <= SCROLL_EDGE;
    const atEnd = maxScroll <= 0 || slider.scrollLeft >= maxScroll - SCROLL_EDGE;

    if (prevBtn) {
      prevBtn.hidden = atStart;
      prevBtn.disabled = atStart;
    }
    if (nextBtn) {
      nextBtn.hidden = atEnd;
      nextBtn.disabled = atEnd;
    }
  }

  function initWrap(wrap) {
    const slider = wrap.querySelector('slider-element');
    const prevBtn = wrap.querySelector('.b2b-technik__nav-button--prev');
    const nextBtn = wrap.querySelector('.b2b-technik__nav-button--next');
    if (!slider || !prevBtn || !nextBtn) return;

    let scrollEndTimer;
    function onScroll() {
      updateButtons(slider, prevBtn, nextBtn);
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(() => updateButtons(slider, prevBtn, nextBtn), 50);
    }

    prevBtn.addEventListener('click', () => {
      const step = getScrollStep(slider);
      slider.scrollBy({ left: -step, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      const step = getScrollStep(slider);
      slider.scrollBy({ left: step, behavior: 'smooth' });
    });

    slider.addEventListener('scroll', onScroll, { passive: true });
    const ro = new ResizeObserver(() => updateButtons(slider, prevBtn, nextBtn));
    ro.observe(slider);

    updateButtons(slider, prevBtn, nextBtn);
  }

  function initAll() {
    document.querySelectorAll(SLIDER_SELECTOR).forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll(SLIDER_SELECTOR).forEach(initWrap);
  });
})();
